import { useTranslation } from 'react-i18next';
import { Box, Grid2, Typography } from '@mui/material';
import { AlertDialog } from '@utriper/core-ui';

const BookingCodeHelper = ({ open = false, onClose = () => {} }) => {
    const { t } = useTranslation();
    const translate = (key) => t(`checkin.booking_code_helper.${key}`);

    return (
        <AlertDialog
            open={open}
            handleClose={onClose}
            hideSubmit
            hideTitle
            maxWidth="xs"
            fullWidth
            labelBack={translate('close_button')}
            dialogContent={
                <Box sx={{ width: '100%', pt: 2, color: '#131313 !important' }}>
                    <Grid2 container direction="column" spacing={2}>
                        <Typography variant="h3" fontSize={20}>
                            {translate('title')}
                        </Typography>
                        <Typography>{translate('description')}</Typography>

                        {/* <Typography variant="h5" fontSize={18} sx={{ textTransform: 'none' }}>
                            Where can I find it?
                        </Typography>

                        <Typography>image</Typography> */}
                    </Grid2>
                </Box>
            }
        />
    );
};

export default BookingCodeHelper;
